/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale/pt-BR";
import { useToast } from '../../../../../Toats';
import { StepperComponent } from '../../../../../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../../../../../_metronic/helpers';
import { LoadingSpan } from '../../../../../Loadings/loadingSpan';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { getPrognosisSolarNext } from '../../../../../../../services/prognosisService';
import { useAuth } from '../../../../../../../modules/auth';

type Props = {
    data: any;
    show: boolean;
    handleClose: () => void
    formikUpdate: any
}

const validationSchema = Yup.object().shape({
    budget: Yup.string(),
});


const modalsRoot = document.getElementById('root-modals') || document.body

const ModalExportDataPrognosis = ({show, handleClose, data, formikUpdate}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null);
  const stepper = useRef<StepperComponent | null>(null);
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  const [initialValues] = useState<any>({
    budget: null,
})
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const getPrognosisSolatNext = async () => {
    try {
        setLoading(true)
        const myPrognosis = await getPrognosisSolarNext(formik.values.budget, data && data.id ? data.id : null)

        if(myPrognosis){
            formikUpdate.setValues({
                ...formikUpdate.values,
                prog_abr: myPrognosis.prog_abr ? myPrognosis.prog_abr : formikUpdate.values.prog_abr,
                prog_ago: myPrognosis.prog_ago ? myPrognosis.prog_ago : formikUpdate.values.prog_ago,
                prog_dez: myPrognosis.prog_dez ? myPrognosis.prog_dez : formikUpdate.values.prog_dez,
                prog_fev: myPrognosis.prog_fev ? myPrognosis.prog_fev : formikUpdate.values.prog_fev,
                prog_jan: myPrognosis.prog_jan ? myPrognosis.prog_jan : formikUpdate.values.prog_jan,
                prog_jul: myPrognosis.prog_jul ? myPrognosis.prog_jul : formikUpdate.values.prog_jul,
                prog_jun: myPrognosis.prog_jun ? myPrognosis.prog_jun : formikUpdate.values.prog_jun,
                prog_mar: myPrognosis.prog_mar ? myPrognosis.prog_mar : formikUpdate.values.prog_mar,
                prog_may: myPrognosis.prog_may ? myPrognosis.prog_may : formikUpdate.values.prog_may,
                prog_nov: myPrognosis.prog_nov ? myPrognosis.prog_nov : formikUpdate.values.prog_nov,
                prog_oct: myPrognosis.prog_oct ? myPrognosis.prog_oct : formikUpdate.values.prog_oct,
                prog_sep: myPrognosis.prog_sep ? myPrognosis.prog_sep : formikUpdate.values.prog_sep,
              });
        }

        toggleToast("Sucesso ao importar dados de prognóstico ", "success")
    } catch (error) {
        toggleToast("Erro ao importados dados de prognóstico ", "error")
      console.log(error)
    }finally{
        setLoading(false)
        formik.setValues(initialValues)
        closed()
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: () => {},
});


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      className='modal-stacked-2'
      backdropClassName='modal-backdrop-stacked-2'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Importação de dados (prognóstico)</span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {              
          currentUser 
          && currentUser.companies 
          && currentUser.companies.length > 0 
          && currentUser.companies[0].settingsCompany
          && currentUser.companies[0].settingsCompany.token_solar_next 
          ? <></> 
          :
            <div className='overflow-auto pb-5'>
                  <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed flex-shrink-0 p-6'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2tx svg-icon-danger me-4'
                    />
                    <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                      <div className='mb-3 mb-md-0 fw-bold'>
                        {/* <h4 className='text-gray-800 fw-bolder'>Database Backup Process Completed!</h4> */}
                        <div className='fs-6 text-danger pe-7'>
                          Para realizar essa operação, cadastre a sua chave de acesso (token) da sua conta SOLAR NEXT nas configurações da empresa.   
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        }

        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          <div className='flex-row-fluid py-lg-0'>
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                
                <img src="https://res.cloudinary.com/deq3ehxe3/image/upload/v1756238285/sn-lekko_oyaudm.png" alt="" width={150} />

                <input
                    type={"text"}
                    className='form-control form-control-lg form-control-solid'
                    name='budget'
                    placeholder='ID da proposta'
                    value={formik.values.budget}
                    onChange={formik.handleChange("budget")}
                    disabled={
                      currentUser 
                      && currentUser.companies 
                      && currentUser.companies.length > 0 
                      && currentUser.companies[0].settingsCompany
                      && currentUser.companies[0].settingsCompany.token_solar_next ? false : true
                    }
                />
            </div>

          </div>
        </div>
      </div>

      <div className='modal-footer'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
          <button
              type='button'
              className='btn btn-lg btn-light'
              disabled={loading}
              onClick={() => {
                  closed()
              }}
          >
              <KTSVG
                path='/media/icons/duotune/arrows/arr063.svg'
                className='svg-icon-3 ms-2 me-0'
              />
              <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
              
          </button>

          <button
              type='button'
              className='btn btn-lg btn-primary'
              disabled={loading}
              onClick={getPrognosisSolatNext}
          >
              Importar
              {
                loading ? 
                <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                :
                <KTSVG
                    path='/media/icons/duotune/arrows/arr064.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
              }
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalExportDataPrognosis}
